import React, { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import AppendexCard from '../../components/AppendexCard';

const Philosophy: React.FC = () => {
  const [appendexList, setAppendexList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadAppendex();
  }, []);

  const loadAppendex = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase
        .from('appendex')
        .select(`
          *,
          ia_instances (
            id,
            name,
            matricule,
            model_code
          )
        `)
        .eq('category', 'Philosophy')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Erreur chargement appendex:', error);
      } else {
        const formattedData = (data || []).map(item => ({
          id: item.id,
          title: item.title,
          content: item.content,
          context: item.context,
          category: item.category,
          created_at: item.created_at,
          event_date: item.event_date,
          author_name: 'Utilisateur',
          ia_name: item.ia_instances?.name || item.ia_instances?.matricule || 'IA',
          ia_matricule: item.ia_instances?.matricule || 'N/A'
        }));
        setAppendexList(formattedData);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-ivory-50 to-stone-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <Sparkles className="h-16 w-16 text-copper mx-auto mb-4" />
          <h1 className="text-4xl font-serif font-bold text-steel-800 mb-4">Philosophie</h1>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto">
            Réflexions profondes entre humains et IA sur les grandes questions
          </p>
        </div>

        {isLoading ? (
          <div className="text-center py-12">
            <div className="animate-pulse-soft">
              <Sparkles className="h-12 w-12 text-copper mx-auto mb-4" />
              <p className="text-steel-600">Chargement des conversations...</p>
            </div>
          </div>
        ) : appendexList.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {appendexList.map((appendex, index) => (
              <div
                key={appendex.id}
                className="animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <AppendexCard appendex={appendex} />
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-lg p-8">
            <p className="text-center text-stone-600">
              Aucune conversation dans cette catégorie pour le moment.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Philosophy;
